<template>
  <div class="login-container">
    <v-container fluid class="login-content">
      <v-row align="center" justify="center">
        <v-col>
          <v-card width="400" class="login-card mx-auto my-5">
            <v-card-title>
              <h3 class="login-title">
                {{ $t('login.title') }}
              </h3>
            </v-card-title>
            <v-card-text>
              <v-form ref="loginForm" v-model="formVadility">
                <v-text-field
                  :label="$t('login.user')"
                  prepend-icon="mdi-account-circle-outline"
                  v-model="user"
                  :rules="userRules"
                  required
                  autofocus
                ></v-text-field>
                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  :label="$t('login.code')"
                  prepend-icon="mdi-lock-outline"
                  ref="loginPassword"
                  v-model="password"
                  id="login-psw"
                  :rules="passRules"
                  :append-icon="
                    showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'
                  "
                  @click:append="toggleShowPassword"
                ></v-text-field>
                <v-card-actions class="justify-center">
                  <v-btn
                    color="primary"
                    type="submit"
                    @click="login($event)"
                    :disabled="!formVadility"
                    >{{ $t('login.submit') }}</v-btn
                  >
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col align="center" class="internal-disclaimer">
          {{ $t('login.use') }}
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { auth } from '../firebase'
import { ADMIN_MAIL, SUPER_MAIL, USER_MAIL } from '@/consts/common'
export default {
  components: {},
  data: () => ({
    user: '',
    password: '',
    showPassword: false,
    formVadility: false
  }),
  computed: {
    userRules() {
      return [v => !!v || this.$t('login.userError')]
    },
    passRules() {
      return [value => !!value || this.$t('login.codeError')]
    },
    loginErrorText() {
      return this.$t('alerts.loginError')
    }
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword
    },
    resetValidation() {
      this.$refs.loginForm.resetValidation()
    },
    resetForm() {
      this.$refs.loginForm.reset()
    },
    login(e) {
      e.preventDefault()
      const self = this
      let email = USER_MAIL
      if (this.password.includes('admin')) email = ADMIN_MAIL
      if (this.password.includes('SUPER')) email = SUPER_MAIL

      auth.signInWithEmailAndPassword(email, this.password).then(
        () => {
          if (window.location.hostname !== 'localhost') {
            //Analytics Event
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'login',
              esAdmin: !self.password.includes('reader'),
              gid: self.user
            })
          }
          var sessionTime = 8 * 60 * 60 * 1000 //48 hours
          localStorage.setItem('bd-kol-session', Date.now() + sessionTime)
          this.$router.push({ name: 'admin' })
        },
        () => {
          if (window.location.hostname !== 'localhost') {
            //Analytics Event
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push({
              event: 'loginError',
              contrasenaErronea: self.password,
              gid: self.user
            })
          }
          alert(this.loginErrorText)
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">
.login-container {
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;

  .login-content {
    margin-top: 8%;
  }

  .v-card.login-card {
    background: rgb(255 255 255 / 81%);
  }
  .login-title {
    color: #003b79;
    width: 100%;
    word-break: break-word;
    text-align: center;
  }

  .internal-disclaimer {
    color: #6987ad;
    font-weight: bold;
  }
}
</style>
